import { render, staticRenderFns } from "./AppMore.vue?vue&type=template&id=27473cec&scoped=true&"
var script = {}
import style0 from "./AppMore.vue?vue&type=style&index=0&id=27473cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27473cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27473cec')) {
      api.createRecord('27473cec', component.options)
    } else {
      api.reload('27473cec', component.options)
    }
    module.hot.accept("./AppMore.vue?vue&type=template&id=27473cec&scoped=true&", function () {
      api.rerender('27473cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_eagle_landing/components/AppMore.vue"
export default component.exports